import ErrorBoundary from 'components/ErrorBoundary';
import AppContent from 'components/AppContent';
import GlobalContextProvider from 'context/GlobalContext/GlobalContext';
import { BrowserRouter } from 'react-router-dom';
import { Userpilot } from 'userpilot';

// Initialize Userpilot
Userpilot.initialize('NX-a83f2f17');

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <GlobalContextProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </GlobalContextProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
